import { t } from "i18next"
import PrefixedInput from "../../../common/PropertyTools/PrefixedInput"

interface Props {
    inputValue: number
    name: string
    label: string
    handleOnChange: (e: any) => void
    /** show "sec" at the end of the field */
    unit?: boolean
}

/** A ticker's timing field — the same compact field as every other section's. */
export const TickerInput = ({ inputValue, name, label, handleOnChange, unit = true }: Props) => (
    <PrefixedInput
        name={name}
        value={inputValue}
        label={label}
        tooltip={label}
        handleOnChange={handleOnChange}
        min={0}
        max={99999}
        error={+inputValue < 0}
        endAdornment={unit ? t("editor:inputAdornmentUnit.sec") : undefined}
    />
)
